import * as React from 'react';
import { AddUsersToGroupDataKeys, AddUsersToGroupTypes } from './AddUsersToGroupGrid';
import { BodyCell } from '@tableau/widgets-datagrid';
import {
  CheckBoxProps,
  CheckBoxWidget,
  Tooltip,
  TooltipPosition
  } from '@tableau/widgets';
import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';

export const ADD_USERS_TO_GROUP_GRID_ROW_CHECKBOX_TEST_ID = 'add-users-to-group-grid-row-';
export const ADD_USERS_TO_GROUP_GRID_ROW_DISPLAYNAME_TEST_ID = 'add-users-to-group-grid-row-displayname-';

export class AddUsersToGroupGridCellFormatter extends React.PureComponent<BodyCell.Props, object> {
  public constructor(props: BodyCell.Props) {
    super(props);
  }

  private renderCheckboxCell(): JSX.Element {
    const checkBoxCellData = this.props.row.data[AddUsersToGroupDataKeys.Select] as AddUsersToGroupTypes.CheckboxCellData;
    const checkboxChecked = checkBoxCellData.checkboxState === CheckboxState.checked;
    const checkboxMixedState = checkBoxCellData.checkboxState === CheckboxState.mixed;
    const checkBoxProps: CheckBoxProps = {
      checked: checkboxChecked,
      handleChange: checkBoxCellData.onCheckboxChanged,
      indeterminate: checkboxMixedState,
      testId: ADD_USERS_TO_GROUP_GRID_ROW_CHECKBOX_TEST_ID + this.props.rowIdx,
      disabled: !checkBoxCellData.isCheckboxEnabled
    };

    return <div>
      <CheckBoxWidget {...checkBoxProps}/>
    </div>;
  }

  private tooltipContent(): JSX.Element {
    const text = this.props.row.data[AddUsersToGroupDataKeys.SiteUserDisplayName] + ' (' + this.props.row.data[AddUsersToGroupDataKeys.SiteUserName] + ')';
    return <span>{text}</span>;
  }

  private renderDisplayNameCellData(): JSX.Element {
    const displayName = this.props.row.data[AddUsersToGroupDataKeys.SiteUserDisplayName];
      return (
        <div>
          <Tooltip
            getContent={() => { return this.tooltipContent();}}
            position={TooltipPosition.Bottom}
          >
            <span
              data-tb-test-id={ADD_USERS_TO_GROUP_GRID_ROW_DISPLAYNAME_TEST_ID + this.props.rowIdx}
            >
              {displayName}
            </span>
          </Tooltip>
        </div>
      );
  }

  private renderRowWithData(): JSX.Element {
    const columnKey = this.props.col.dataKey as AddUsersToGroupDataKeys;

    switch(columnKey) {
      case AddUsersToGroupDataKeys.Select:
        return this.renderCheckboxCell();
      case AddUsersToGroupDataKeys.SiteUserDisplayName:
        return this.renderDisplayNameCellData();
      default:
        return <React.Fragment />;
    }
  }

  public render(): JSX.Element {
    const row: AddUsersToGroupTypes.Row = this.props.row as AddUsersToGroupTypes.Row;
    return this.renderRowWithData();
  }
}

const AddUsersToGroupGridCellFormatterFactory = React.createFactory(AddUsersToGroupGridCellFormatter);

export { AddUsersToGroupGridCellFormatterFactory };
